import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  socialLinks?: {
    icon?: string;
    url?: string;
  }[]
}

const propsSchema: PropsSchemaList = [
  {
    key: 'socialLinks',
    label: 'Social Links',
    type: types.ARRAY,
    children: [
      {
        key: 'icon',
        label: 'Icon',
        type: types.ENUM,
        options: [
          'facebook',
          'youtube',
          'twitter',
          'instagram',
          'pinterest',
          'wechat',
          'wecom',
          'weibo',
          'tiktok',
          'linkedin',
        ]
      },
      {
        key: 'url',
        label: 'url',
        type: types.TEXT,
      },
    ]
  },
];

const defaultProps: Props = {
  socialLinks: [
    {
      icon: 'facebook',
      url: 'https://www.facebook.com/faradayfuture/'
    },
    {
      icon: 'youtube',
      url: 'https://www.youtube.com/c/faradayfuture'
    },
    {
      icon: 'twitter',
      url: 'https://twitter.com/FaradayFuture'
    },
    {
      icon: 'instagram',
      url: 'https://www.instagram.com/faradayfuture/'
    },
    {
      icon: 'pinterest',
      url: 'https://www.pinterest.com/faradayfuture/'
    },
    {
      icon: 'wechat',
      url: ''
    },
    {
      icon: 'wecom',
      url: ''
    },
    {
      icon: 'weibo',
      url: 'http://weibo.com/u/5801670517'
    },
    {
      icon: 'tiktok',
      url: 'https://www.tiktok.com/@faradayfuture'
    },
    {
      icon: 'linkedin',
      url: 'https://www.linkedin.com/company/faradayfuture/'
    },
  ]
};

export default {
  title: 'Simple Footer',
  id: 'SimpleFooter',
  propsSchema,
  defaultProps,
}
